import React, { useState } from "react";
import CircularProgress from "../../../components/CircularProgress";
import { Feedback } from "../../../componentLibrary/Feedback";
import Button from "../../../componentLibrary/Button";
import { LessonI, ImageTypeEnum } from "../../../types";
import { useNotification } from "../../../hooks/useNotification";

const mockLesson: LessonI = {
  filter: {},
  _id: "1",
  title: "Lesson 1",
  icon: {
    src: "https://d2c85asnp7to29.cloudfront.net/1719712048502-Relationship_couple_with_heart.svg",
    key: "1719712048502-Relationship_couple_with_heart.svg",
    name: "Relationship couple with heart",
    alt: "Relationship couple with heart",
    type: ImageTypeEnum.ILLUSTRATION,
  },
  pages: [],
};

export default function FeedbackComponents() {
  const [progressPercent, setProgressPercent] = useState(10);
  const { notify } = useNotification();

  return (
    <>
      <h2 className="underline">Feedback & Notifications</h2>

      <div className="space-y-6">
        {/* Footer Notifications */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">
            Footer Notifications
          </h3>
          <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
            <p className="text-sm text-gray-700">
              Global notification system used throughout the application for
              user feedback. Displays success, error, and info messages for form
              submissions, data operations, and user actions. Uses the
              NotificationContext and is triggered via the useNotification hook.
            </p>
          </div>
          <div className="space-y-2">
            <Button
              variant="primary"
              onClick={() => notify("success", "Success notification!")}
            >
              Show Success Notification
            </Button>
            <Button
              variant="cautionary"
              onClick={() => notify("error", "Error notification!")}
            >
              Show Error Notification
            </Button>
            <Button
              variant="secondary"
              onClick={() => notify("info", "Info notification!")}
            >
              Show Info Notification
            </Button>
          </div>
        </div>

        {/* Circular Progress */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">
            Circular Progress
          </h3>
          <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
            <p className="text-sm text-gray-700">
              Progress indicators for showing completion status in modules and
              lessons throughout the application. Provides visual feedback for
              user progress and task completion.
            </p>
          </div>
          <div className="flex items-center space-x-4">
            <CircularProgress
              percentage={progressPercent}
              icon="https://d2c85asnp7to29.cloudfront.net/1719712048502-Relationship_couple_with_heart.svg"
            />
            <Button
              size="sm"
              onClick={() =>
                setProgressPercent((prev) => Math.min(prev + 10, 100))
              }
            >
              +10%
            </Button>
          </div>
        </div>

        {/* Feedback Component */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">
            Feedback Component
          </h3>
          <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
            <p className="text-sm text-gray-700">
              User feedback collection component for gathering lesson responses
              and user opinions. Used in lesson pages and content areas to
              collect structured feedback from users. Provides standardized way
              to gather user input and improve content quality.
            </p>
          </div>
          <Feedback lesson={mockLesson} />
        </div>
      </div>
    </>
  );
}
